import React from 'react';
import WeekProgress from './WeekProgress';

const TabContentPlanificacion = ({ temaActual, vueltasCompletadas }) => {
  return (
    <div className="tab-content planificacion-content">
      <WeekProgress 
        temaActual={temaActual} 
        vueltasCompletadas={vueltasCompletadas} 
      />
      
      <div className="planificacion-info">
        <h4>Sobre las vueltas al temario</h4>
        <p>
          El sistema de repaso está diseñado para reforzar tus conocimientos de Informática Justicia 2025 a lo largo de 6 semanas.
          Cada semana te centrarás en un tema específico, con tests destacados para practicar.
        </p>
        <p>
          Al completar las 6 semanas, habrás completado una vuelta al temario completo y comenzarás una nueva vuelta 
          con material adicional para seguir mejorando tus conocimientos.
        </p>
      </div>
    </div>
  );
};

export default TabContentPlanificacion;